import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVkComponent } from './simple-icons-vk.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVkComponent ],
    exports:      [ SimpleIconsVkComponent ],
    bootstrap:    []
})
export class SimpleIconsVkModule {}
